import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';
export function TopBar() {
  return <div className="bg-brand-red text-white text-xs md:text-sm font-medium py-2 overflow-hidden relative z-50" data-id="element-129">
      <div className="flex w-max animate-[scroll_25s_linear_infinite]" data-id="element-130">
        {[...Array(2)].map((_, i) => <div key={i} aria-hidden={i === 1} className="flex items-center gap-8 px-4 whitespace-nowrap shrink-0" data-id="element-131">
            <span data-id="element-132">Oferta de lanzamiento disponible hoy</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-133" />
            <span data-id="element-134">Acceso inmediato + bonos incluidos</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-135" />
            <span data-id="element-136">Edición de lanzamiento con precio especial</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-137" />
            <span data-id="element-138">Hoy entrás al archivo con beneficios exclusivos</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-139" />
          </div>)}
      </div>
    </div>;
}
export function WhatsAppButton() {
  return <motion.a href="https://wa.link/39bl5r" target="_blank" rel="noopener noreferrer" aria-label="Contactanos por WhatsApp" initial={{
    opacity: 0,
    scale: 0.8
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.94
  }} className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#25D366] shadow-[0_4px_20px_rgba(37,211,102,0.4)]" data-id="element-140">
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white" aria-hidden="true" data-id="element-141">
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.978-1.717zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.017-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-142" />
      </svg>
    </motion.a>;
}
const UPSELLS = ['Antártida: El Continente Prohibido', 'Los Evangelios Perdidos'];
const notifications = [{
  name: 'Martín Gauna',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Sofía Benítez',
  location: 'Córdoba, Argentina'
}, {
  name: 'Lucas Ferreyra',
  location: 'Rosario, Argentina'
}, {
  name: 'Camila Quiroga',
  location: 'Mendoza, Argentina'
}, {
  name: 'Tomás Acosta',
  location: 'La Plata, Argentina'
}, {
  name: 'Valentina Ríos',
  location: 'Mar del Plata, Argentina'
}, {
  name: 'Nicolás Sosa',
  location: 'San Miguel de Tucumán, Argentina'
}, {
  name: 'Julieta Medina',
  location: 'Salta, Argentina'
}, {
  name: 'Federico Luna',
  location: 'Neuquén, Argentina'
}, {
  name: 'Agustina Vega',
  location: 'Santa Fe, Argentina'
}, {
  name: 'Matías Ojeda',
  location: 'San Juan, Argentina'
}, {
  name: 'Florencia Cabrera',
  location: 'Resistencia, Argentina'
}, {
  name: 'Diego Navarro',
  location: 'Santiago, Chile'
}, {
  name: 'Mariana Pérez',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Andrés Restrepo',
  location: 'Bogotá, Colombia'
}, {
  name: 'Daniela Flores',
  location: 'Lima, Perú'
}];
type ActiveNotification = {
  name: string;
  location: string;
  upsell: string;
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<ActiveNotification | null>(null);
  useEffect(() => {
    // Initial delay of 12-15 seconds
    const initialDelay = Math.floor(Math.random() * 3000) + 12000;
    const showNextNotification = () => {
      const person = notifications[Math.floor(Math.random() * notifications.length)];
      const upsell = UPSELLS[Math.floor(Math.random() * UPSELLS.length)];
      setCurrent({
        ...person,
        upsell
      });
      // Hide after 5 seconds
      setTimeout(() => {
        setCurrent(null);
      }, 5500);
    };
    const initialTimer = setTimeout(() => {
      showNextNotification();
      // Show subsequent notifications every 20-30 seconds
      setInterval(() => {
        showNextNotification();
      }, Math.floor(Math.random() * 10000) + 20000);
    }, initialDelay);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-143">
      {current !== null && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.9,
      transition: {
        duration: 0.2
      }
    }} className="fixed bottom-5 left-4 md:left-8 z-50 bg-brand-card border border-brand-anthracite shadow-2xl rounded-lg p-3 flex items-start gap-3 max-w-[300px]" data-id="element-144">
          <div className="bg-brand-dark p-2 rounded-full border border-brand-gold/30 shrink-0 mt-0.5" data-id="element-145">
            <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-146" />
          </div>
          <div className="flex-1" data-id="element-147">
            <p className="text-xs text-brand-offWhite font-medium leading-snug" data-id="element-148">
              <span className="font-bold text-white" data-id="element-149">{current.name}</span> de{' '}
              {current.location}
            </p>
            <p className="text-[10px] text-brand-muted mt-1 leading-snug" data-id="element-150">
              accedió a la colección{' '}
              <span className="text-brand-gold/90" data-id="element-151">NOS MIENTEN</span> y sumó{' '}
              <span className="text-brand-gold/90" data-id="element-152">{current.upsell}</span>
            </p>
          </div>
          <button onClick={() => setCurrent(null)} aria-label="Cerrar notificación" className="text-brand-muted hover:text-white shrink-0" data-id="element-153">
            <X className="w-3 h-3" data-id="element-154" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}